import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

export const Location = () => {
  const address = {
    street: 'Rod. Washington Luiz, s/n - Jardim Gramacho',
    city: 'Duque de Caxias',
    state: 'RJ',
    country: 'Brasil'
  };

  const openGoogleMaps = () => {
    window.open('https://maps.app.goo.gl/pdFvZyBuURPqApgt7', '_blank');
  };

  return (
    <section id="localizacao" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-red-600 font-semibold text-sm uppercase tracking-wider">Localização</span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-bold text-gray-900">
            Onde Estamos
          </h2>
          <p className="mt-4 text-xl text-gray-600 max-w-3xl mx-auto">
            Localização estratégica para atender toda a região com eficiência
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Address Card */}
          <Card className="p-8 shadow-lg hover:shadow-xl transition-all duration-300">
            <div className="flex items-center mb-6">
              <div className="flex items-center justify-center w-16 h-16 bg-red-600 rounded-xl">
                <MapPin className="text-white" size={32} />
              </div>
              <h3 className="ml-4 text-2xl font-bold text-gray-900">SSA DISTRIBUIDORA</h3>
            </div>

            <div className="space-y-4">
              <div>
                <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-1">Endereço</p>
                <p className="text-lg text-gray-900 font-medium">{address.street}</p>
                <p className="text-lg text-gray-900">{address.city} – {address.state}</p>
                <p className="text-lg text-gray-900">{address.country}</p>
              </div>

              <div className="pt-4 border-t border-gray-200">
                <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-2">Horário de Funcionamento</p>
                <div className="space-y-1">
                  <p className="text-gray-700"><span className="font-semibold">Segunda a Sexta:</span> 08:00 - 18:00</p>
                  <p className="text-gray-700"><span className="font-semibold">Sábado:</span> Fechado</p>
                  <p className="text-gray-700"><span className="font-semibold">Domingo:</span> Fechado</p>
                </div>
              </div>

              <Button
                onClick={openGoogleMaps}
                className="w-full bg-gray-700 hover:bg-gray-800 text-white mt-6"
                size="lg"
              >
                <Navigation className="mr-2" size={20} />
                Abrir no Google Maps
              </Button>
            </div>
          </Card>

          {/* Map Placeholder */}
          <div className="relative h-96 lg:h-full min-h-[400px] rounded-2xl overflow-hidden shadow-lg">
            <iframe
              title="Localização SSA DISTRIBUIDORA"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3677.0!2d-43.2867!3d-22.6456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x997803e6a3f4a5%3A0x0!2sSSA+DISTRIBUIDORA+DE+AUTOPE%C3%87AS!5e0!3m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="grayscale hover:grayscale-0 transition-all duration-500"
            />
          </div>
        </div>

      </div>
    </section>
  );
};